const onlyFullField = (data) => {
  if (!data) return {}

  if (Object.entries(data).length) {
    const arrayFields = Object.entries(data).filter(([prop, val]) => prop && val)

    return Object.fromEntries(arrayFields)
  }
}

export default onlyFullField;
